import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit {

  date : Date = new Date();

  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}

  ngOnInit(): void {
    
    this.oidcSecurityService.isAuthenticated().subscribe((res: any) => {
      console.log('llllllll:',res);
      
      if(res || res == true) {
        this.router.navigate(['/admin/dashboard']);
      } else {
        this.oidcSecurityService.authorize(undefined, {
          customParams: {
            requestCulture: 'fa-IR'
          }
        });
      }
    })
  }

  login() {
    this.oidcSecurityService.authorize(undefined, {
      customParams: {
        requestCulture: 'fa-IR'
      }
    });
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe((res: any) => {
      console.log(res);
      
    });
  }
}
